export enum ECarePlanFrequency {
  WEEKLY = "weekly",
  TWICE_WEEK = "twice_week",
  OTHER_WEEK = "other_week",
}
